import { render, staticRenderFns } from "./BnAlertMessage.vue?vue&type=template&id=5c370a7d&"
import script from "./BnAlertMessage.vue?vue&type=script&lang=js&"
export * from "./BnAlertMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports